//Images
const inviewClass = 'in-view';
const imageSelectors = document.querySelectorAll('.wpk-animate, .is-style-wpk-animate');
const imageOptions = { rootMargin: '0px', threshold: 0.2 };
let imageObserver;

//Function for observe/unobserve and adding class
function onImageIntersection(entries) {
    // Loop through the entries
    entries.forEach(entry => {
        //If we are in viewport
        if (entry.intersectionRatio > 0) {
            // Add class
            entry.target.classList.add(inviewClass);
            // Stop watching the object
            imageObserver.unobserve(entry.target);
        }
    });
}
//function for running above observer. Reusable for ajax loading.
function wpkImageLoader(imageSelectors) {

    //If we have newer browsers
    if (('IntersectionObserver' in window)) {

        imageObserver = new IntersectionObserver(onImageIntersection, imageOptions); //Call function

        //Run function for all image selectors
        imageSelectors.forEach(selector => {
            imageObserver.observe(selector);
        });

    //If we have older browsers
    } else {

        //Add class to all elements directly
        //Convert node to array, and then loop
        Array.prototype.forEach.call(imageSelectors, function(item) {
            item.classList.add(inviewClass);
        });
        
    }
}

//Run function with default targets on load 
wpkImageLoader(imageSelectors);